import React from 'react';
import { AppContent } from '@common/components';
import { BillingDisputeList } from '@pay-bill/components';

export const BillingDisputesTab = ({
  isSupplier,
  invoiceCode,
  revInvoiceCode,
}: {
  isSupplier: boolean;
  invoiceCode?: string;
  revInvoiceCode?: string;
}) => {
  const invoiceCodes = invoiceCode ? [invoiceCode] : undefined;
  const revInvoiceCodes = revInvoiceCode ? [revInvoiceCode] : undefined;

  return (
    <AppContent left={false} right={false} top={false}>
      <BillingDisputeList
        viewMode={isSupplier ? 'revInvoiceDetails' : 'invoiceDetails'}
        additionalFilters={{
          invoiceCode: invoiceCodes,
          revInvoiceCode: revInvoiceCodes,
        }}
      />
    </AppContent>
  );
};
